<template>
  <Modal v-model="visible" @on-ok="resetError" :title="getTranslation('s326')" @on-cancel="closeError"
      :okText="getTranslation('c015')" :cancelText="getTranslation('b182')" closable mask-closable>
    <Row class="table-header">
        <Col flex="1" class="table-cell">{{ getTranslation('m009') }}</Col>
        <Col flex="2" class="table-cell">{{ getTranslation('k223') }}</Col>
      </Row>
      <template v-if="errorData && errorData.alarms">
      <Row v-for="(item) in errorData.alarms" :key="item.id" class="table-row" >
        <Col flex="1" class="table-cell">{{ KindList[item.kind] }}</Col>
        <Col flex="2" class="table-cell">{{ item.msg }}</Col>
      </Row>
      </template>
  </Modal>

</template>
<script>
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Modal, Row, Col } from 'view-design';
import { mapGetters } from 'vuex'
import {  postJsError } from '@/util/util.js'
export default {
  name: 'WarnList', // 组件名称
  components: {
    Modal, Row, Col,
  },
  props: {
    propVisible: Boolean,
    errorData: Object
  },
  data() {
    return {  

    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    },
      KindList() {
      return [
        this.getTranslation("k255"),
        this.getTranslation("c015"),
      ]
    },
  },
  watch: {
   
  },

  created() {

  },
  methods: {
  
    ok() {
       this.visible = false
    },
     resetError() {
      let url = API_URL["machineWarnReset"];
      if (!this.errorData.macId) {
        this.$Message.error(this.getTranslation('k402'));
        return;
      }
      let params = {
        mac: this.errorData.macId
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })

    },
    closeError() {
      this.$emit('close-error')
    }

   
  },

}
</script>

<style scoped>
.desc-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 3%;
  font-size: 0.9rem;
  font-weight: 500;
}

.field-line {
  margin-bottom: 8px;
}
</style>